import { TLocale } from "@src/i18n";

export function locale(): TLocale {
  // TODO: Add logic to get the `locale` from the `path` on `containers`
  return (document.documentElement.lang as TLocale) || "ja";
}
